const Button = ({
  children,
  onClick,
  type = "button",
  variant = "primary",
  size = "md",
  disabled = false,
  className = "",
  ...props
}) => {
  const baseClasses =
    // "font-semibold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed border rounded";
    "font-medium transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed rounded";

  const variantClasses = {
    primary: "btn-primary-new",
    secondary: "btn-secondary-new",
    danger: "btn-danger-new",
    success: "btn-success-new",
    outline: "btn-outline-primary",
    neutral: "bg-gray-50 border border-gray-200 text-gray-700 hover:bg-gray-100",

    quickCreateIssueType: "hover:bg-surface-secondary",
    icon: "bg-transparent border-0",

    /* NEW: dropdown / list item for create issue page bottom in assignee icon in popup for used */
    menu: "bg-transparent border-0 text-gray-700 hover:bg-surface-secondary",
  };

  const sizeClasses = {
    vsm: "px-1 py-1",
    sm: "btn-sm px-3 py-1.5",
    md: "px-4 py-2",
    lg: "px-6 py-3 text-lg",
  };

  const classes = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`;

  return (
    <button type={type} onClick={onClick} disabled={disabled} className={classes} {...props}>
      {children}
    </button>
  );
};

export default Button;
